import { COLLECTIONS } from "@/mocks/gua";

export default function Collections() {
  return (
    <section id="collection" className="w-full border-b border-stone-200/60 bg-white">
      <div className="mx-auto w-full px-4 py-10 md:px-6 md:py-14">
        <div className="flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <p className="text-xs font-semibold uppercase tracking-wider text-amber-600">主题合集 · 补课入口</p>
            <h2 className="mt-1.5 text-2xl font-extrabold text-stone-900 md:text-3xl">
              按题材收好的瓜田合集
            </h2>
            <p className="mt-2 text-sm text-stone-500">
              想按题材一次看个够？这里把零散新瓜归成合集，索引更醒目，少走弯路直捣瓜田。
            </p>
          </div>
          <a href="#zone" className="whitespace-nowrap text-sm font-medium text-amber-600 hover:text-amber-700">
            查看全部合集 <i className="ri-arrow-right-line align-[-1px]" />
          </a>
        </div>

        <div className="mt-6 grid gap-3 sm:grid-cols-2 lg:grid-cols-3 md:gap-4">
          {COLLECTIONS.map((c) => (
            <a
              key={c.name}
              href="#scene"
              className={`group relative flex flex-col overflow-hidden rounded-lg border p-5 transition ${
                c.accent
                  ? "border-orange-200 bg-gradient-to-br from-orange-50 to-amber-50/60 hover:border-orange-300"
                  : "border-stone-200/70 bg-[#fdfbf6] hover:border-amber-200 hover:bg-amber-50/40"
              }`}
            >
              {c.accent && (
                <span className="absolute right-3 top-3 rounded-full bg-orange-600 px-2 py-0.5 text-[10px] font-bold text-white">
                  本周主打
                </span>
              )}
              <span
                className={`flex h-11 w-11 items-center justify-center rounded-xl text-xl ${
                  c.accent ? "bg-orange-600 text-white" : "bg-amber-100 text-amber-700"
                }`}
              >
                <i className={c.icon} />
              </span>
              <h3 className="mt-4 text-base font-bold text-stone-900 group-hover:text-orange-700">{c.name}</h3>
              <p className="mt-1.5 text-xs leading-relaxed text-stone-500">{c.desc}</p>
              <span className="mt-4 flex items-center gap-1 text-[11px] font-semibold text-stone-400">
                <i className="ri-file-list-3-line" />
                {c.count}
                <span className="ml-auto inline-flex items-center gap-1 text-amber-600 opacity-0 transition group-hover:opacity-100">
                  进合集 <i className="ri-arrow-right-line" />
                </span>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}